import React from "react";


export default function MenuButtons({ menu, onChoose }) {
    if (!menu) return null;
    return (
        <div className="mt-3 space-y-2">
            {menu.prompt && <div className="font-medium">{menu.prompt}</div>}
            <div className="flex gap-2 flex-wrap">
                {menu.options.map((opt) => (
                    <button key={opt.id} className="btn btn-outline-primary btn-sm" onClick={() => onChoose(opt.id, opt.label)}>
                        {opt.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
